import api from '../../api';

export const teacherAccountService = {
    generateUniqueHandle: async (teacherId) => {
        const response = await api.get(`/teachers/${teacherId}/handle/generate`);
        return response.data;
    },
    updateHandle: async (handle) => {
        const response = await api.post('/teachers/handle', { handle });
        console.log('response', response);
        return response.data;
    }
}